module.exports = __webpack_public_path__ + "media/Part3.ca320881.mp4";